import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
function isValidPythonClassName(value) {
    // Regex explanation:
    // ^[A-Z]: Starts with an uppercase letter (ensures PascalCase/CamelCase).
    // [a-zA-Z0-9]*$: Followed by zero or more alphanumeric characters (letters or numbers).
    // This ensures no special characters or spaces are present and allows numbers after the initial uppercase letter.
    const regex = /^[A-Z][a-zA-Z0-9]*$/;
    return regex.test(value);
}
// Check that the node has a value for the 'command' field
// eslint-disable-next-line max-params
export function validateCommand(node, nodeFields, accept) {
    const { idField, commandField, nodeTypeField } = nodeFields;
    // command is only for action nodes
    if (nodeTypeField?.nodeType?.value === 'D')
        return;
    if (!commandField || ast.isEmptyField(commandField?.command)) {
        accept('error', `Missing required 'command' field for node '${node.name}'.`, {
            node: commandField || node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node.name,
                propertyName: FRONTEND_PROPERTY_NAME.COMMAND,
            },
        });
    }
    else {
        const command = commandField.command.value;
        if (!isValidPythonClassName(command)) {
            accept('error', `The command '${command}' needs to be a valid python class name in camel-case convention.`, {
                node: commandField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.COMMAND,
                },
            });
        }
    }
}
//# sourceMappingURL=validate-command.js.map